function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Space, Button, Tabs, Image } from "antd";
import Moment from "react-moment";
import SignatureCanvas from "react-signature-canvas";
import { ArrowClockwise, XCircle } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SignConsent = function SignConsent(_ref) {
  var set_sign = _ref.set_sign,
    _ref$candidat = _ref.candidat,
    candidat = _ref$candidat === void 0 ? null : _ref$candidat,
    _ref$ro = _ref.ro,
    ro = _ref$ro === void 0 ? false : _ref$ro,
    _ref$company = _ref.company,
    company = _ref$company === void 0 ? null : _ref$company;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    signatureImage = _useState2[0],
    setSignatureImage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var signatureCanvasRef = useRef(null);
  var clearSignature = function clearSignature() {
    signatureCanvasRef.current.clear();
    setSignatureImage("");
  };
  var saveSignature = function saveSignature() {
    setSignatureImage(signatureCanvasRef.current.getTrimmedCanvas().toDataURL("image/png"));
    set_sign(signatureCanvasRef.current.getTrimmedCanvas().toDataURL("image/png"));
    console.log(signatureImage);
  };
  var sendSignature = function sendSignature() {
    if (signatureImage == "" || signatureImage == null) {
      notification.error({
        message: "Erreur",
        description: "Singature introuvable"
      });
      return;
    }
  };
  var tabsItem = [{
    key: 1,
    label: /*#__PURE__*/_jsx("b", {
      children: "FR"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [(candidat && candidat.company && candidat.company.protocole == "rio" || company && company.protocole == "rio") && /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 12,
            md: 12,
            children: /*#__PURE__*/_jsx("div", {
              className: "pad cool-radius",
              style: {
                background: "#FFDE08",
                padding: "10px"
              },
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("h4", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "AVIS DE CONFIDENTIALIT\xC9 :"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: "Simfer S.A., membre du groupe Rio Tinto, s'engage \xE0 prot\xE9ger la sant\xE9 et la s\xE9curit\xE9 de notre main-d'\u0153uvre et des visiteurs de nos exploitations en Guin\xE9e. L'approbation m\xE9dicale est obligatoire avant de travailler pour le projet Simandou."
                }), /*#__PURE__*/_jsx("p", {
                  children: "L'\xE9valuation m\xE9dicale remplie doit \xEAtre soumise \xE0 simfermedicalteam@riotinto.com pour approbation. Une \xE9valuation approuv\xE9e est valable 12 mois."
                }), /*#__PURE__*/_jsx("p", {
                  children: "Les donn\xE9es personnelles demand\xE9es sur ce formulaire (vos donn\xE9es personnelles) comprennent des informations de sant\xE9 d\xE9taill\xE9es vous concernant qui sont n\xE9cessaires aux fins suivantes :"
                }), "\u2022 D\xE9terminer si vous \xEAtes apte \xE0 travailler sur le projet Simandou ;", /*#__PURE__*/_jsx("br", {}), "\u2022 Vous prodiguer les soins m\xE9dicaux appropri\xE9s si n\xE9cessaire ;", /*#__PURE__*/_jsx("br", {}), "\u2022 s'assurer que vous avez re\xE7u tous les vaccins obligatoires ;", /*#__PURE__*/_jsx("br", {}), "\u2022 S'assurer que vous avez \xE9t\xE9 inform\xE9 et qu'on vous a propos\xE9 les vaccins vivement recommand\xE9s", " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
                  children: "La raison pour laquelle nous recueillons ces informations de sant\xE9 tient au fait que travailler sur le projet Simandou pose des risques sanitaires importants. Il s'agit entre autres de l'acc\xE8s limit\xE9 aux installations et prestations m\xE9dicales, des retards lors des \xE9vacuations m\xE9dicales et de diverses maladies infectieuses et \xE0 transmission vectorielle."
                }), /*#__PURE__*/_jsxs("p", {
                  children: ["Vos donn\xE9es personnelles seront trait\xE9es par l'\xE9quipe m\xE9dicale Simfer du projet Simandou. Si des anomalies m\xE9dicales sont constat\xE9es sur votre formulaire d'\xE9valuation, l'\xE9quipe m\xE9dicale de Simfer est susceptible de partager vos donn\xE9es personnelles avec un m\xE9decin externe engag\xE9 pour fournir des prestations \xE0 Rio Tinto. Vos donn\xE9es personnelles ne seront partag\xE9es avec personne d'autre, sauf s'il faut vous administrer un traitement m\xE9dical urgent ou vous \xE9vacuer en raison d'un probl\xE8me m\xE9dical grave. Dans de telles circonstances, il peut s'av\xE9rer n\xE9cessaire de partager vos donn\xE9es personnelles avec l'\xE9quipe sanitaire de Rio Tinto ou autres professionnels de la sant\xE9 fournissant des prestations \xE0 Rio", /*#__PURE__*/_jsx("p", {
                    children: "Tinto tels qu'International SOS, ou votre assureur (en ne communiquant syst\xE9matiquement que le strict n\xE9cessaire)."
                  }), "Rio Tinto s'appuie sur ses int\xE9r\xEAts l\xE9gitimes pour traiter ces donn\xE9es personnelles vous concernant, et plus particuli\xE8rement sur son int\xE9r\xEAt \xE0 assurer la sant\xE9 et la s\xE9curit\xE9 au travail. Vos donn\xE9es personnelles seront conserv\xE9es conform\xE9ment aux exigences l\xE9gales en mati\xE8re de conservation des dossiers m\xE9dicaux."]
                }), /*#__PURE__*/_jsx("p", {
                  children: "En vertu de la norme de confidentialit\xE9 des donn\xE9es de Rio Tinto (disponible \xE0 l'adresse https://www.riotinto.com/sustainability/policies), vous disposez de droits en mati\xE8re de confidentialit\xE9 des donn\xE9es, notamment du droit de consultation ou rectification des fiches contenant vos donn\xE9es personnelles, et d'\xEAtre renseign\xE9 sur le traitement des donn\xE9es. Pour exercer les droits de la personne concern\xE9e \xE9nonc\xE9s dans la norme de confidentialit\xE9 des donn\xE9es, veuillez contacter Simfermedicalteam@riotinto.com ou envoyer un courriel \xE0 askE&C@riotinto.com."
                }), /*#__PURE__*/_jsxs("p", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Attestation et consentement :"
                  }), " je confirme avoir lu le pr\xE9sent avis de confidentialit\xE9 et consentir au traitement de mes donn\xE9es personnelles (dont mes informations de sant\xE9) comme expos\xE9 ci-dessus. Je comprends \xE9galement que le traitement de mes donn\xE9es personnelles (dont mes informations de sant\xE9) peut \xEAtre effectu\xE9 si n\xE9cessaire afin de respecter les obligations l\xE9gales de Rio Tinto, et que lorsque le traitement de mes donn\xE9es personnelles (dont mes informations de sant\xE9) se fonde sur mon consentement, je peux r\xE9voquer ce consentement en informant Simfermedicalteam@riotinto.com."]
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          className: "pad cool-radius",
          style: {
            background: "#CDD6E0",
            padding: "10px"
          },
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Space, {
                direction: "vertical",
                children: /*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {})
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 5,
              md: 5,
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "SIGNATURE"
                  })
                }), ro == false && candidat == null ? /*#__PURE__*/_jsx("div", {
                  className: "sign_zone",
                  children: /*#__PURE__*/_jsx(SignatureCanvas, {
                    penColor: "#585650",
                    ref: signatureCanvasRef,
                    canvasProps: {
                      width: 240,
                      height: 180,
                      border: "1px solid #E78174",
                      className: "sigCanvas"
                    },
                    onEnd: function onEnd() {
                      setSignatureImage(signatureCanvasRef.current.getTrimmedCanvas().toDataURL("image/png"));
                      set_sign(signatureCanvasRef.current.getTrimmedCanvas().toDataURL("image/png"));
                      console.log(signatureImage);
                    }
                  })
                }) : /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsx(Image, {
                    style: {
                      cursor: "pointer"
                    },
                    preview: false,
                    src: candidat.sign_consent,
                    width: "100%"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    textAlign: "center"
                  },
                  children: /*#__PURE__*/_jsx(Space, {
                    direction: "horizontal",
                    children: ro == false && /*#__PURE__*/_jsx(Button, {
                      type: "link",
                      onClick: clearSignature,
                      children: /*#__PURE__*/_jsx(ArrowClockwise, {
                        size: 28
                      })
                    })
                  })
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 4,
              md: 4,
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "DATE"
                  })
                }), /*#__PURE__*/_jsx(Moment, {
                  format: "DD/MM/YYYY"
                })]
              })
            })]
          })
        })]
      })
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsx("b", {
      children: "EN"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 12,
            md: 12,
            children: /*#__PURE__*/_jsx("div", {
              className: "pad cool-radius",
              style: {
                background: "#FFDE08",
                padding: "10px",
                height: "480px",
                overflow: ro == true ? "" : "scroll"
              },
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("h4", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "PRIVACY NOTICE :"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: "Simfer SA is a member of the Rio Tinto Group and is committed to protecting the health and safety of our workforce. Medical assessment and approval is required prior to travelling to Guinea for the Simandou Project"
                }), /*#__PURE__*/_jsx("p", {
                  children: "The medical assessment must be conducted at an approved Clinic and results submitted to the Simfer Medical Team at simfermedicalteam@riotinto.com for review and approval."
                }), /*#__PURE__*/_jsx("p", {
                  children: "The personal data requested on this form (your personal data) includes detailed health information about you and is required for the purposes of"
                }), "\u2022 determining if you are fit for travel to Guinea and work on Simandou project.", /*#__PURE__*/_jsx("br", {}), "\u2022 providing you with appropriate medical care if needed whilst you are in Guinea.", /*#__PURE__*/_jsx("br", {}), "\u2022 ensuring you have all the mandatory vaccinations.", /*#__PURE__*/_jsx("br", {}), "\u2022 ensuring you have been advised and offered the highly recommended vaccinations. \u2022 ensuring you have been advised that malaria chemoprophylaxis is highly recommended.", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
                  children: "The purpose of requiring this information is because working in Guinea poses significant health risks. This includes limited access to medical facilities and services, exposure to a range of vector borne and infectious diseases, and delays in medical evacuation should it be required. These factors may impact your health and especially if you have a pre-existing medical condition"
                }), /*#__PURE__*/_jsx("p", {
                  children: "Your personal data will be processed by the Simfer Medical Team for the Simandou Project. If there are medical abnormalities noticed on your assessment form, the Simfer Medical Team may share your personal data with an external doctor engaged to provide services to Rio Tinto. Your personal data will not be shared with anyone else unless you require urgentmedicaltreatmentand/orneedtobeevacuatedbecauseyouhaveaseriousmedicalproblem. Insuchcircumstances your personal data may need to be shared with the Rio Tinto Health team or other health professionals providing services to Rio Tinto such as International SOS, or your insurance provider (on a strictly 'need to know' basis)."
                }), /*#__PURE__*/_jsx("p", {
                  children: "Rio Tinto relies on its legitimate interests to process this personal data relating to you, and specifically its interest in ensuring workplace health and safety. If you are a Rio Tinto employee based in a country where your consent is needed in order to collect your personal data or your health information or both, Rio Tinto relies on your consent to do so. Your personal data will be retained for the period that you are assigned to the Simandou project, after which time it will be archived for a two- year period and then securely deleted."
                }), /*#__PURE__*/_jsx("p", {
                  children: "Under the Rio Tinto Data Privacy Standard (available from https://www.riotinto.com/sustainability/policies) you have data privacy rights, including the right to seek access to or rectification of records containing your personal data and to be provided with information data processing. To exercise data subject rights described in the Data Privacy Standard, please contact Simfermedicalteam@riotinto.com or email askE&C@riotinto.com."
                }), /*#__PURE__*/_jsxs("p", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Acknowledgement and Consent:"
                  }), " I confirm that I have read this Privacy Notice and that I agree to the processing of my personal data (including my health information) as described above. I also understand that processing of my personal data (including my health information) may be undertaken where necessary to comply with Rio Tinto\u2019s legal obligations and that where processing of my personal data (including my health information) is based on my consent, I can withdraw that consent by notifying Simfermedicalteam@riotinto.com"]
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          className: "pad cool-radius",
          style: {
            background: "#CDD6E0",
            padding: "10px"
          },
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Space, {
                direction: "vertical",
                children: /*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {})
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 5,
              md: 5,
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "SIGNATURE"
                  })
                }), ro == false && candidat == null ? /*#__PURE__*/_jsx("div", {
                  className: "sign_zone",
                  children: /*#__PURE__*/_jsx(SignatureCanvas, {
                    penColor: "#585650",
                    ref: signatureCanvasRef,
                    canvasProps: {
                      width: 240,
                      height: 180,
                      border: "1px solid #E78174",
                      className: "sigCanvas"
                    },
                    onEnd: function onEnd() {
                      setSignatureImage(signatureCanvasRef.current.getTrimmedCanvas().toDataURL("image/png"));
                      set_sign(signatureCanvasRef.current.getTrimmedCanvas().toDataURL("image/png"));
                      console.log(signatureImage);
                    }
                  })
                }) : /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsx(Image, {
                    style: {
                      cursor: "pointer"
                    },
                    preview: false,
                    src: candidat.sign_consent,
                    width: "100%"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    textAlign: "center"
                  },
                  children: /*#__PURE__*/_jsx(Space, {
                    direction: "horizontal",
                    children: ro == false && /*#__PURE__*/_jsx(Button, {
                      type: "link",
                      onClick: clearSignature,
                      children: /*#__PURE__*/_jsx(ArrowClockwise, {
                        size: 28
                      })
                    })
                  })
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 4,
              md: 4,
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "DATE"
                  })
                }), /*#__PURE__*/_jsx(Moment, {
                  format: "DD/MM/YYYY"
                })]
              })
            })]
          })
        })]
      })
    })
  }];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Tabs, {
      items: tabsItem,
      animate: true
    })
  });
};
export default SignConsent;